<template lang="pug">
	#sfc-main-container
		.header(role="banner")
			b-container
				b-row
					b-col(lg="12" md="12")
						.logo
							img.cm.img-fluid(v-if="cm" :src="`${$store.state.config.s3ResourceHost}/images/columbia-management-logo-2025.png`" style="width:230px;" alt="Columbia Management Logo")
							img.fs.img-fluid(v-if="fs" :src="`${$store.state.config.s3ResourceHost}/images/fs-logo-2023.jpg`" alt="Future Scholar Logo")
							img.ts.img-fluid(v-if="ts" :src="`${$store.state.config.s3ResourceHost}/images/logo_tomorrows_scholar.jpeg`" alt="Tomorrow's Scholar Logo")
							img.ia.img-fluid(v-if="ia" :src="`${$store.state.config.s3ResourceHost}/images/IAdvisor-logo.png`" alt="IAdvisor Logo")

		#sfc-main-content(role="main")
			.content
				nuxt
</template>
<style lang="stylus" scoped>
	@import '~assets/css/variables.styl'

	#sfc-main-container
		font-family: IBM Plex Sans,sans-serif!important
		background: #fff
		.header
			padding: 25px 0 50px
			.logo
				margin: 0 auto
				img
					&.fs
						width: 308px
					&.cm
						width: 488px
					&.ia
						width: 180px
		h1
		h2
		h3
		b
			font-family: "IBM Plex Serif",serif!important
</style>

<script>
export default {

	data(){
		let fs = false
		let cm = false
		let ts = false
		let ia = false

		if (this.$route.query.layout && this.$route.query.layout == "cm") {
			cm = true
		}
		if (this.$route.query.layout && this.$route.query.layout == "fs") {
			fs = true
		}
		if (this.$route.query.layout && this.$route.query.layout == "ts") {
			ts = true
		}
		if (this.$route.query.layout && this.$route.query.layout == "ia") {
			ia = true
		}

		// When adding more companies here, the var in $store.state.financialAidCalculatorLicensedCompanies needs to be updated as well

		return{
			fs,
			cm,
			ts,
			ia
		}
	}
}
</script>
